export const QA_NAME_ENTITY_TAB_PROVIDERS_ADD_NEW = 'entityTabProvidersAddNew'
